// SPDX-FileCopyrightText: Copyright 2026 Dash0 Inc.

"use client";

import { ArrowRightIcon } from "lucide-react";

import { ButtonLink } from "@/components/ui/button";

interface CtaBannerProps {}
export function CtaBanner({}: CtaBannerProps) {
  // Returning null for now. The CTA Banner support we need to add to make the hub content render.
  // CTA Banner is only used in a section which we only want to render in the products UI, not hte website.
  // So leaving this component as a placeholder for now, until we can add the support for it in the hub content rendering.
  return null;
}
